import { render } from "./EventCard.vue?vue&type=template&id=e6d06050&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=e6d06050&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e6d06050"

export default script